//域名
const domain = window.location.host + "/api";

//端口
const port = null;

//路径
const root = window.location.protocol + "//" + domain + (port ? (":" + port) : "");

//接口
const api = {
    cmsCommon:{
        uploadFile:`${root}/cmsCommon/uploadFile`,
        downloadVideo:`${root}/cmsCommon/downloadVideo`
    },
    cmsCategory:{
        list:`${root}/cmsCategory/list`,
        add:`${root}/cmsCategory/add`,
        update:`${root}/cmsCategory/update`,
        delete:`${root}/cmsCategory/delete`,
        batchDelete:`${root}/cmsCategory/batchDelete`,
        detail:`${root}/cmsCategory/detail`,
        tree:`${root}/cmsCategory/tree`,
    },
    partner:{
        list:`${root}/partner/list`,
        add:`${root}/partner/add`,
        update:`${root}/partner/update`,
        delete:`${root}/partner/delete`,
        batchDelete:`${root}/partner/batchDelete`,
        detail:`${root}/partner/detail`
    },
    cmsArticle:{
        upload:`${root}/cmsArticle/upload`,
        list:`${root}/cmsArticle/list`,
        add:`${root}/cmsArticle/add`,
        update:`${root}/cmsArticle/update`,
        delete:`${root}/cmsArticle/delete`,
        batchDelete:`${root}/cmsArticle/batchDelete`,
        detail:`${root}/cmsArticle/detail`
    },
    userFeedback:{
        upload:`${root}/userFeedback/upload`,
        list:`${root}/userFeedback/list`,
        add:`${root}/userFeedback/add`,
        update:`${root}/userFeedback/update`,
        delete:`${root}/userFeedback/delete`,
        batchDelete:`${root}/userFeedback/batchDelete`,
        detail:`${root}/userFeedback/detail`
    },
    deviceStat:{
        upload:`${root}/deviceStat/upload`,
        list:`${root}/deviceStat/list`,
        add:`${root}/deviceStat/add`,
        update:`${root}/deviceStat/update`,
        delete:`${root}/deviceStat/delete`,
        batchDelete:`${root}/deviceStat/batchDelete`,
        detail:`${root}/deviceStat/detail`,
        statCount:`${root}/deviceStat/statCount`
    },
    sysConfig:{
        detail:`${root}/sysConfig/detail`,
        config:`${root}/sysConfig/config`
    }
};

export default Object.assign(
    {
        $base: {
            domain: domain,
            port: port,
            root: root,
        },


    },
    api
)
